import { combineReducers } from 'redux';
import scribeConversation from './scribeConversation';
import scribeSession from './scribeSession';
import scribeTranscriptUI from './scribeTranscriptUI';
import firebase from './firebase';
import scribeNotifications from './scribeNotifications';
import scribeTrainings from './scribeTrainings';
import scribeDashboard from './scribe-dashboard';
import accountReducer from './account';
import savedTranscriptReducer from './saved-transcript';
import rateConversationReducer from './rate-conversation';
import audioRecorderReducer from './audio-recorder';
import ccModeReducer from './cc-mode';
const rootReducer = combineReducers({
    scribeConversation,
    scribeSession,
    scribeTranscriptUI,
    firebase,
    scribeNotifications,
    scribeTrainings,
    scribeDashboard,
    account: accountReducer,
    savedTranscript: savedTranscriptReducer,
    rateConversation: rateConversationReducer,
    audioRecorder: audioRecorderReducer,
    ccMode: ccModeReducer,
});
export default rootReducer;
